import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { AccessTime as TimeIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const SessionExpiredDialog = () => {
  const { sessionExpired, clearSessionExpired, logout } = useAuth();
  const navigate = useNavigate();

  const handleRelogin = async () => {
    await logout();
    clearSessionExpired();
    navigate('/login');
  };

  // Убираем фокус с активного элемента при открытии модалки
  React.useEffect(() => {
    if (sessionExpired && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }, [sessionExpired]);

  return (
    <Dialog 
      open={sessionExpired} 
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      disableRestoreFocus
    >
      <DialogTitle sx={{ textAlign: 'center', pt: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <TimeIcon sx={{ fontSize: 48, color: 'warning.main' }} />
          <Typography variant="h6">
            Сессия истекла
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          Ваша сессия завершена по истечении времени. 
          Пожалуйста, войдите снова для продолжения работы.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button 
          variant="contained" 
          onClick={handleRelogin}
          size="large"
          autoFocus
        >
          Войти снова
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;

